export default __webpack_public_path__ + "static/media/plain-sticker-oa.24bda7b4.png";